"use strict";

module.exports = require("./is-implemented")()
	? Number.isNaN
	: require("./shim");



//////////////////
// WEBPACK FOOTER
// ./node_modules/es5-ext/number/is-nan/index.js
// module id = 499
// module chunks = 0